<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">会员中心</router-link></li>
                <li class="currentNode"><a>下载记录</a></li>
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>
                        <span>下载记录</span>
                        <!-- <button class="addUpload" @click="goRegister()"><i class="el-icon-circle-plus"></i>添加</button> -->
                    </h3>
                    <el-divider></el-divider>
                    <el-table
                        class="theadTable"
                        :data="tableData"
                        stripe>
                        <el-table-column
                            label="ID"
                            min-width="50"
                            prop="ID">
                        </el-table-column>
                        <el-table-column
                            label="分类"
                            min-width="130"
                            prop="OrderType">
                        </el-table-column>
                        <el-table-column
                            label="名称"
                            min-width="400"
                            prop="OrderName">
                        </el-table-column>
                        <el-table-column
                            label="下载时间"
                            min-width="100"
                            prop="CTime">
                        </el-table-column>
                        <!-- <el-table-column
                            label="报名时间"
                            width="150"
                            prop="CTime">
                        </el-table-column> -->
                        <!-- <el-table-column
                            label="操作"
                            width="150">
                            <template slot-scope="scope">
                                <el-button class="textBtn" @click="goDetail(scope.row)" type="text" size="small">详情</el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    getDownList,
} from '@services/tokenService.js';
import { getCookie } from '@/assets/utils/cookie.js'
export default {
    name: '',
    components: { PersonCenterMenu },
    data() {
        return {
            checkStatusList: [
            {
                    label: '审核通过',
                    value: '10'
                },
                {
                    label: '审核失败',
                    value: '-10'
                },
                {
                    label: '待审核',
                    value: '0'
                },
            ],
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
        };
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
    },
    created() {
        if (this.accountId === '') {
            this.$router.push(
                {
                    path: '/layout/login',
                }
            );
        } 
        this.getDownList();
    },
    methods: {
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getDownList();
        },
        goEdit(data) {
            this.$router.push(
                {
                    path:'/layout/upload-city-style',
                    query: {
                        id: data.Id,
                    }
                }
            );
        },
        getDownList() {
            let param = {
                accountid: this.accountId,
                current: this.currentPage,
                size: this.pageSize,
            };
            getDownList(param).then(res => {
                if(res.Code === 1) {
                    this.tableData = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error("活动报名请求失败！");
                }
            })
        }
    },
};
</script>

<style scoped>
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: left;
    margin-bottom: 0;
    padding-bottom: 0;
    display:flex;
    justify-content: space-between;
    align-items: center;
}
.theadTable {
    box-shadow: -2px -2px 16px 1px #00000026;
    margin-bottom: 30px;
}
.vertical-nav li a.active {
    border-left: none;
}
.textBtn {
    color: #4E5969;
}


</style>